import { render, staticRenderFns } from "./ItemClientTypeReportPrint.vue?vue&type=template&id=62ec521e&"
import script from "./ItemClientTypeReportPrint.vue?vue&type=script&lang=js&"
export * from "./ItemClientTypeReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports